import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { useStepper } from "../../../hooks/use-stepper.desktop";
import { dekstopStyle } from "../../../constants/style-constants";
import LeadProgress from "../lead-progress";
// import { TABS } from "../../../utils/funnel/steps.desktop";
import styles from "./styles.css";
import ErrorHandler from "../../shared/with-error-handler";
import { parseLeadProgress } from "../lead-progress-bar/selectors";

// eslint-disable-next-line max-statements
const LeadForm = ({
    formConfig: {
        stepper,
        tabs,
        stepNames,
        flowName,
        tabData
    },
    progressBarData,
    leadData,
    setStepConnect,
    setDataConnect,
    activateLastStepConnect,
    setFlowNameConnect,
    setVisitedStateConnect,
    setProgressBarDataConnect
}) => {
    const {
        currentStep,
        prevTabIndex,
        currentStepIndex,
        currentTabIndex,
        proceedCTA,
        brand: { displayText: selectedBrand },
        model: { displayText: selectedModel },
        year: { displayText: selectedYear },
        variant: { displayText: selectedVairant }
    } = leadData;

    const [step, prev, next, renderStep] = useStepper(currentStep, stepper);
    const {
        mountStyle,
        defaultStyle,
        currentStyle,
        visibilityHidden,
        visibilityShown
    } = dekstopStyle;
    const [style, setStyle] = useState(mountStyle);
    const [prevStyle, setVisibility] = useState(visibilityShown);
    const [parentStyle, setParentStyle] = useState({ position: "relative" });
    const nextRef = useRef();
    const currentRef = useRef();
    const prevRef = useRef();

    const setParentStyles = () => {
        const parentStyles = {
            position: "relative",
            marginTop: "20px",
            minHeight: `${currentRef.current.clientHeight}px`
        };
        setParentStyle(parentStyles);
    };

    const slideAnimate = () => {
        const animateInStyle = {
            position: "relative",
            top: "-500px",
            transition: "top .2s ease-in"
        };
        setStyle(animateInStyle);
        window.setTimeout(() => {
            setVisibility(visibilityHidden);
            // eslint-disable-next-line no-magic-numbers
        }, 150);
    };

    useEffect(() => {
        setVisitedStateConnect(0, "active");
    }, [setVisitedStateConnect]);

    useEffect(() => {
        renderStep();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [renderStep]);

    useEffect(() => {
        setFlowNameConnect(flowName);
    }, [flowName, setFlowNameConnect]);

    useEffect(() => {
        window.setTimeout(() => {
            setParentStyles();
            // eslint-disable-next-line no-magic-numbers
        }, 50);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStep]);

    useEffect(() => {
        if (prev) {
            if (prevTabIndex > currentTabIndex && currentTabIndex !== 1) {
                setStyle({
                    ...mountStyle,
                    top: "-1000px"
                });
            } else {
                setStyle(mountStyle);
            }
            window.setTimeout(() => {
                slideAnimate();
            }, 0);
        } else {
            setStyle(mountStyle);
        }
        return () => {
            setVisibility(visibilityShown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStep]);

    const onTabClick = stepValue => {
        setStepConnect({ currentStep: stepValue, tabs });
    };

    const onProceedClick = () => {
        activateLastStepConnect(true);
    };

    return (
        <div styleName={"styles.leadFormPanel"}>
            <span styleName={"styles.carDetail"}>
                {`${selectedBrand} ${selectedModel} ${selectedYear} ${selectedVairant}`}
            </span>
            <ErrorHandler>
                <LeadProgress
                    tabs={tabs}
                    stepNames={stepNames}
                    onTabClick={onTabClick}
                    currentStepIndex={currentStepIndex}
                    currentTabIndex={currentTabIndex}
                />
            </ErrorHandler>
            <div style={parentStyle}>
                <div style={style} >
                    {
                        prev &&
                        <div ref={prevRef} style={{ ...prevStyle, ...defaultStyle }}>
                            <prev.component referenceStore={leadData} />
                        </div>
                    }
                    <div ref={currentRef} style={{ ...currentStyle, ...defaultStyle }}>
                        {step &&
                            <step.component
                                proceedCTA={proceedCTA}
                                onProceedClick={onProceedClick}
                                prevStep={prev}
                                setData={(data) => setDataConnect(data, { stepper, tabs, tabData })}
                                nextStep={() => {
                                    const data = parseLeadProgress({
                                        type: flowName,
                                        key: currentStep,
                                        progressBarData
                                    });
                                    setProgressBarDataConnect(data);
                                    setStepConnect({ currentStep: next.name, tabs });
                                }}
                                referenceStore={leadData}
                            />
                        }
                    </div>
                    {
                        next &&
                        <div ref={nextRef} className="invisible" style={{ ...defaultStyle }}>
                            <next.component referenceStore={leadData} />
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

LeadForm.propTypes = {
    leadData: PropTypes.object.isRequired,
    setStepConnect: PropTypes.func.isRequired,
    setDataConnect: PropTypes.func.isRequired,
    formConfig: PropTypes.object,
    activateLastStepConnect: PropTypes.func.isRequired,
    progressBarData: PropTypes.array,
    setFlowNameConnect: PropTypes.func,
    setVisitedStateConnect: PropTypes.func,
    setProgressBarDataConnect: PropTypes.func
};

export default LeadForm;
